module.exports = __webpack_public_path__ + "img/banner.2e200094.png";